import React from 'react';
import * as PropTypes from 'prop-types';
import './Panels.css';
import i18next from "i18next";
import {useTranslation} from "react-i18next";
import {Col, Row, Skeleton, Spin, Typography} from "antd";
import NumberPlate from "../image/NumberPlate";
import {MainImage} from "../image/MainImage";
import {getRandomInt, getMyVehicleTitleKey} from "../../utility/global-util";
import {useScreenSizeBelow} from "../../utility/hooks/useScreenSize";

const { Title } = Typography;


// const StatusWidget = (status) => {
//    return (<Row align="middle">
//         <Col>
//             { status.status.code = "warn" ?
//             <ExclamationCircleFilled className="dp-vehicle-status-warn"/>
//             :
//             <CheckCircleFilled className="dp-vehicle-status-icon" />}
//         </Col>
//         <Col>
//             <Text className="dp-vehicle-status-text">{status.status.description}</Text>
//         </Col>
//     </Row>)
// }

const VehicleLoading = ({ mobile, middle = false, style = {} }) => {
    return (
        <Row align="middle" style={style}>
            <Spin size="small" style={{ marginRight: '5px' }} />
            { mobile || middle
              ? <></>
              : <Title level={4}>{i18next.t('message.loading','loading')}<span className=" dp-flashing-dots">...</span></Title> }
        </Row>
    );
}

const VehicleCard = ({ loading, pageLoading = false, contract, customTitle }) => {

    const eligibleForTabBar = useScreenSizeBelow(769);
    const middleSize = useScreenSizeBelow(992);

    const vehicle = contract?.contractVehicle;
    const { t } = useTranslation();

    return (
        vehicle
          ? <div key={getRandomInt(1, 1000)}>
                <Row>
                    <Col xs={24} sm={24} md={12} lg={14} xl={14}>
                        <Row className="dp-vehicle-info">
                            <Title level={3}>{customTitle || t(getMyVehicleTitleKey())}</Title>
                            {eligibleForTabBar && (pageLoading || loading)
                              ? <VehicleLoading mobile={true} style={{ marginLeft: '5px' }} />
                              : <></>}
                        </Row>
                        <Row align="middle" className="dp-vehicle-info">
                            <Col>
                                <NumberPlate loading={loading} countryCode={vehicle.countryCode} registrationNo={vehicle.regNo} alternativeReg={vehicle.alternativeRegNo} />
                            </Col>
                            {/*<Col>
                            <StatusWidget status={vehicle.vehicle.status}/>
                         </Col>*/}
                        </Row>
                        <Row className="dp-vehicle-info">
                            <Title level={5} style={{ marginBottom: '0' }}>{vehicle.modelDescription}</Title>
                        </Row>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={3} xl={3}>
                        {!eligibleForTabBar && (pageLoading || loading)
                            ?
                            <div className="my-vehicle-loading"><VehicleLoading mobile={false} middle={middleSize} /></div>
                            : <></>}
                    </Col>
                    <Col xs={0} sm={0} md={9} lg={6} xl={6}>
                        {
                            vehicle.imageUrl && !loading
                                ?
                                <MainImage imageSrc={vehicle.imageUrl + '&zoomType=fullscreen&angle=23'} isExternal="true" className="dp-panel-frame-image"/>
                                :
                                <Skeleton active title={false} paragraph={{ rows: 4 }} />
                        }
                    </Col>
                    <Col xs={0} sm={0} md={1} lg={1} xl={1}><></></Col>
                </Row>
            </div>
          : <></>
    );
}

// Validate prop type parameters.
VehicleCard.propTypes = {
    loading: PropTypes.bool.isRequired,
    contract: PropTypes.object.isRequired,
};

export default VehicleCard;